var map = {
	"./02.png": 5686,
	"./03.png": 3775,
	"./04.png": 5120,
	"./05.png": 9945,
	"./06.png": 4802,
	"./07.png": 3803,
	"./08.png": 3916,
	"./09.png": 6805,
	"./10.png": 9391,
	"./11.png": 374,
	"./12.png": 1613,
	"assets/games/theme-two/slot/spinner/02.png": 5686,
	"assets/games/theme-two/slot/spinner/03.png": 3775,
	"assets/games/theme-two/slot/spinner/04.png": 5120,
	"assets/games/theme-two/slot/spinner/05.png": 9945,
	"assets/games/theme-two/slot/spinner/06.png": 4802,
	"assets/games/theme-two/slot/spinner/07.png": 3803,
	"assets/games/theme-two/slot/spinner/08.png": 3916,
	"assets/games/theme-two/slot/spinner/09.png": 6805,
	"assets/games/theme-two/slot/spinner/10.png": 9391,
	"assets/games/theme-two/slot/spinner/11.png": 374,
	"assets/games/theme-two/slot/spinner/12.png": 1613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6169;